import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styles from './clickOutside.scss'

class ClickOutside extends React.Component {
  constructor(props) {
    super(props)

    this.handleDocumentClick = this.handleDocumentClick.bind(this)
  }

  componentDidMount() {
    const { container } = this.props

    if (container) {
      container.addEventListener('click', this.handleDocumentClick)
    }
  }

  componentWillUnmount() {
    const { container } = this.props

    if (container) {
      container.removeEventListener('click', this.handleDocumentClick)
    }
  }

  handleDocumentClick(e) {
    const { onClickOutside } = this.props

    if (!onClickOutside) return false

    if (!this.clickContainer.contains(e.target)) return onClickOutside(e)

    return null
  }

  render() {
    const { className, children, block } = this.props

    const clickOutsideClass = classNames(styles.clickOutside, className, {
      [styles.block]: block
    })

    return (
      <div
        className={clickOutsideClass}
        ref={(node) => {
          this.clickContainer = node
        }}
      >
        {children}
      </div>
    )
  }
}

ClickOutside.defaultProps = {
  onClickOutside: null,
  className: null,
  children: null,
  block: false,
  container: document
}

ClickOutside.propTypes = {
  onClickOutside: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  block: PropTypes.bool,
  container: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func
  })
}

export default ClickOutside
